"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _MyTopHands = _interopRequireDefault(require("./MyTopHands"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MyTopHandsWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(MyTopHandsWrapper, _React$Component);
  var _super = _createSuper(MyTopHandsWrapper);
  function MyTopHandsWrapper(props) {
    var _this;
    _classCallCheck(this, MyTopHandsWrapper);
    _this = _super.call(this, props);
    _this.toggleCommonFlag = function () {
      console.log("toggleCommonFlag");
      _this.setState({
        showMoreBothFlag: !_this.state.showMoreBothFlag
      });
    };
    _this.state = {
      showMoreBothFlag: false
    };
    return _this;
  }
  _createClass(MyTopHandsWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var myHandLists = [{
        type: "won",
        hands: this.props.playerReports.topHands.topWonHands
      }, {
        type: "lost",
        hands: this.props.gameType === 'tournament' ? this.props.playerReports.topHands.topLostHands.sort(function (a, b) {
          return b.profit - a.profit;
        }) : this.props.playerReports.topHands.topLostHands
      }];
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "MyTopHandsWrapper"
      }, myHandLists.map(function (listData, i) {
        return /*#__PURE__*/_react["default"].createElement(_MyTopHands["default"], {
          i18next: _this2.props.i18next,
          key: i,
          "data-e2e": "".concat(_this2.props.isMyStatistics ? "myStats-" : "", "top").concat(listData.type === "won" ? "Won" : "Lost", "Hands"),
          isMyStatistics: _this2.props.isMyStatistics,
          desktopView: _this2.props.desktopView,
          showMoreBothFlag: _this2.state.showMoreBothFlag,
          domain: _this2.props.domain,
          isLiveview: _this2.props.isLiveview,
          hands: listData.hands,
          currency: _this2.props.currency ? _this2.props.currency : 'USD',
          gameType: _this2.props.gameType,
          handListType: listData.type,
          handReplayerOpen: function handReplayerOpen(item, lossOrwon) {
            return _this2.props.handReplayerOpen(item, lossOrwon);
          },
          setStarFlagOfHnad: _this2.props.setStarFlagOfHnad,
          toggleCommonFlag: _this2.toggleCommonFlag
        });
      })));
    }
  }]);
  return MyTopHandsWrapper;
}(_react["default"].Component);
var _default = MyTopHandsWrapper;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/MyTopHandsWrapper.js
 ** module id = 2388
 ** module chunks = 0
 **/